import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

export const ThemeToggle = ({ variant = 'header', dark = false, onToggle }) => {
  const cls = variant === 'header'
    ? 'text-white hover:bg-white/10 hover:text-white'
    : 'hover:bg-muted';

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cls}
      onClick={onToggle}
      data-testid="theme-toggle"
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </Button>
  );
};
